$(document).ready(function(){

  
  $(window).on('scroll',function(){
    $("#myAudio").trigger('pause');
  });
  
  // testimonials slider homepage
  $('.testimonial-slick-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:"<div class='pre-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M10.2833 0C10.4021 0 10.5236 0.0469492 10.6147 0.138072C10.797 0.320318 10.797 0.618543 10.6147 0.800789L4.37683 7.04143L10.5236 13.1882C10.7058 13.3704 10.7058 13.6687 10.5236 13.8509C10.3413 14.0332 10.0431 14.0332 9.86088 13.8509L3.38278 7.3728C3.20053 7.19056 3.20053 6.89232 3.38278 6.71007L9.952 0.138086C10.0431 0.0469629 10.1646 2.73438e-05 10.2834 2.73438e-05L10.2833 0Z' fill='white'/></svg></div>",
    nextArrow:"<div class='next-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.71666 0C3.59792 0 3.47641 0.0469492 3.38529 0.138072C3.20305 0.320318 3.20305 0.618543 3.38529 0.800789L9.62317 7.04143L3.47641 13.1882C3.29417 13.3704 3.29417 13.6687 3.47641 13.8509C3.65866 14.0332 3.95687 14.0332 4.13912 13.8509L10.6172 7.3728C10.7995 7.19056 10.7995 6.89232 10.6172 6.71007L4.048 0.138086C3.95687 0.0469629 3.8354 2.73438e-05 3.71664 2.73438e-05L3.71666 0Z' fill='white'/></svg></div>",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // testimonials slider homepage
  var $slider = $('.index-slick-desk ul.collection-list');
    var slickInitialized = false;

    function initSlickDesktop() {
      var windowWidth = $(window).width();

      // Initialize Slick only for tablet & desktop (>=768px)
      if (windowWidth >= 768 && !slickInitialized) {
        $slider.slick({
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          prevArrow: "<div class='pre-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M10.2833 0C10.4021 0 10.5236 0.0469492 10.6147 0.138072C10.797 0.320318 10.797 0.618543 10.6147 0.800789L4.37683 7.04143L10.5236 13.1882C10.7058 13.3704 10.7058 13.6687 10.5236 13.8509C10.3413 14.0332 10.0431 14.0332 9.86088 13.8509L3.38278 7.3728C3.20053 7.19056 3.20053 6.89232 3.38278 6.71007L9.952 0.138086C10.0431 0.0469629 10.1646 0 10.2834 0Z' fill='white'/></svg></div>",
          nextArrow: "<div class='next-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.71666 0C3.59792 0 3.47641 0.0469492 3.38529 0.138072C3.20305 0.320318 3.20305 0.618543 3.38529 0.800789L9.62317 7.04143L3.47641 13.1882C3.29417 13.3704 3.29417 13.6687 3.47641 13.8509C3.65866 14.0332 3.95687 14.0332 4.13912 13.8509L10.6172 7.3728C10.7995 7.19056 10.7995 6.89232 10.6172 6.71007L4.048 0.138086C3.95687 0.0469629 3.8354 0 3.71664 0Z' fill='white'/></svg></div>",
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 992, // Tablet
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
        slickInitialized = true;
      }

      // Destroy Slick on mobile (<768px)
      else if (windowWidth < 768 && slickInitialized) {
        $slider.slick('unslick');
        slickInitialized = false;
      }
    }

    // Run on load
    initSlickDesktop();

    // Re-run when window resizes (with debounce)
    var resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initSlickDesktop, 200);
    });
  
  // product page slider image change swatch
  $('input.custom_swatch').click(function(){
    setTimeout(function() { 
      var current_url = window.location.href;
      var current_url_split = current_url.split('?')[1];
      var current_url_split_new = current_url_split.split('=')[1];
      
      $('.colors_variants').each(function(){
        var variants_id = $(this).attr('variants-id');
        if(current_url_split_new == variants_id ) {
          var selected_image = $(this).attr('varinat-image');
          var selected_image_new = selected_image.split('/')[6];
          var selected_image_new1 = selected_image_new.split('?')[0];
          
          $('.custon_images_variants').each(function(){
            var variants_slider_img = $(this).attr('src');
            if(variants_slider_img.includes(selected_image_new1)){
              $(this).trigger('click'); 
            }
          });
        }
      });
    }, 500);
  });

  // product page tabs
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    
    $(this).find('a').click(function(e){
      active.removeClass('active');
      active.parents('.cgt-desc').find('.main-content').addClass('cgt-content');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  
    $(this).find('.reviews').click(function(e){
      $(this).parents('.cgt-desc').find('.main-content').removeClass('cgt-content');
    });
  
  });

  $('.sitewide-product .apps_enabled #judgeme_product_reviews').hide();

  $('.sitewide-product a.reviews').click(function(){
    $('.sitewide-product .apps_enabled #judgeme_product_reviews').show();
  });
    
  $('a.description.active').click(function(){
    $('.sitewide-product .apps_enabled #judgeme_product_reviews').hide();
  });

  // product-page-direct-checkout-btn
  $(".rediredct-checkout").click(function(ev){
    ev.preventDefault();
    $("form[data-type='add-to-cart-form']").attr("action", "checkout");
    document.location.href = '/checkout';
    return;
  });

});